export default "__VITE_ASSET__i4HXNS5Z__"